// extracted by mini-css-extract-plugin
export default {"button":"button_button__lSRMX","button--small":"button_button--small__xgoJc","button--big":"button_button--big__-kM0M"};